import {
  databases,
  APPWRITE_DB_ID,
  APPWRITE_JOBS_COLLECTION_ID,
  APPWRITE_SAVEDJOBS_COLLECTION_ID,
} from "../AppWrite/appwrite";
import { Query, ID } from "appwrite";

// ✅ Get all jobs
export const fetchGetAllJobs = async (type = null) => {
  try {
    let allJobs = [];
    let lastId = null;

    while (true) {
      const queries = [Query.orderDesc("$createdAt"), Query.limit(100)];
      if (type) queries.push(Query.equal("Type", type));
      if (lastId) queries.push(Query.cursorAfter(lastId));

      const response = await databases.listDocuments(
        APPWRITE_DB_ID,
        APPWRITE_JOBS_COLLECTION_ID,
        queries
      );

      allJobs = [...allJobs, ...response.documents];

      if (response.documents.length < 100) break;
      lastId = response.documents[response.documents.length - 1].$id;
    }

    return { success: true, jobs: allJobs };
  } catch (e) {
    console.error("Error fetching jobs:", e);
    return { success: false, message: "Failed to fetch jobs" };
  }
};

// ✅ Get job by ID
export const fetchGetJobById = async (jobId) => {
  try {
    const response = await databases.getDocument(
      APPWRITE_DB_ID,
      APPWRITE_JOBS_COLLECTION_ID,
      jobId
    );
    return { success: true, data: response };
  } catch (e) {
    console.error("Error fetching job by ID:", e);
    return { success: false, message: "Job not found" };
  }
};

// ✅ Create job
export const fetchCreateJob = async (payload) => {
  try {
    const response = await databases.createDocument(
      APPWRITE_DB_ID,
      APPWRITE_JOBS_COLLECTION_ID,
      ID.unique(),
      {
        Title: payload.title,
        Description: payload.description,
        Country: payload.country,
        City: payload.city,
        Company: payload.company,
        WorkType: payload.workType,
        Experience: payload.experience,
        Batch: payload.batch,
        Degree: payload.degree,
        ApplyURL: payload.applyURL,
        Skills: payload.skills,
        CompanyDescription: payload.companyDescription,
        Salary: payload.salary,
        Responsibilities: payload.responsibilities,
        Type: payload.type,
      }
    );
    return { success: true, data: response };
  } catch (e) {
    console.error("Error creating job:", e);
    return { success: false, message: "Failed to create job" };
  }
};

// ✅ Save job
export const fetchSaveJobs = async ({ UserId, JobId }) => {
  try {
    const res = await databases.createDocument(
      APPWRITE_DB_ID,
      APPWRITE_SAVEDJOBS_COLLECTION_ID,
      ID.unique(),
      { UserId, JobId } // 👈 fixed field names
    );
    return { success: true, jobId: res.JobId };
  } catch (e) {
    console.error("Error saving job:", e);
    return { success: false, message: "Failed to save job" };
  }
};

// ✅ Unsave job
export const fetchUnSaveJobs = async ({ UserId, JobId }) => {
  try {
    const savedJobs = await databases.listDocuments(
      APPWRITE_DB_ID,
      APPWRITE_SAVEDJOBS_COLLECTION_ID,
      [Query.equal("UserId", UserId), Query.equal("JobId", JobId)]
    );

    if (savedJobs.documents.length > 0) {
      await databases.deleteDocument(
        APPWRITE_DB_ID,
        APPWRITE_SAVEDJOBS_COLLECTION_ID,
        savedJobs.documents[0].$id
      );
    }
    return { success: true, jobId: JobId };
  } catch (e) {
    console.error("Error unsaving job:", e);
    return { success: false, message: "Failed to unsave job" };
  }
};

// ✅ Get saved jobs
export const fetchGetSavedJobs = async ({ UserId }) => {
  try {
    const response = await databases.listDocuments(
      APPWRITE_DB_ID,
      APPWRITE_SAVEDJOBS_COLLECTION_ID,
      [Query.equal("UserId", UserId)]
    );
    return response.documents.map((doc) => doc.JobId);
  } catch (e) {
    console.error("Error fetching saved jobs:", e);
    return [];
  }
};
